import { ampFetch } from './api';
import { find, has } from 'lodash';
import { isLoggedIn } from '~/account/utilities/helpers';
import { deleteInvoice } from './washes';

const prepaidWashes = {
    deleteInvoice: async (invoiceId, garage) => {
        deleteInvoice(invoiceId, garage).catch((e) => {
            console.error(e.message);
        });
    },
    deleteInvoiceById: (id, cartItems) => {
        const item = find(cartItems, {
            cartItemId: id,
            productType: 'digital'
        });
        const invoiceId = item?.invoice?.stripe_invoice_id;
        const garage = item?.vehicle?.garage;

        if (item && invoiceId && garage) {
            deleteInvoice(invoiceId, garage).catch((e) => {
                console.error(e.message);
            });
        }
    },
    getPrepaidPurchases: async (email) => {
        return await ampFetch({
            route: 'api-user/prepaid-wash-promotions/get-purchases',
            options: {
                method: 'POST',
                body: JSON.stringify({
                    email
                })
            }
        });
    },
    validatePurchase: async (quantity, promotion_id, email) => {
        return await ampFetch({
            route: 'api/prepaid-wash-promotions/validate-purchase',
            options: {
                method: 'POST',
                body: JSON.stringify({
                    quantity,
                    promotion_id,
                    email
                })
            }
        });
    },
    updateItemWithInvoice: (data, item, refreshKey) => {
        if (!has(data, 'stripe_invoice_id')) {
            console.error(`No invoice found for `, data);
            return item;
        }

        return {
            ...item,
            refreshKey,
            tax: data.tax || 0,
            invoice: data,
            metadata: {
                amount_due: data.amount_due,
                mobile_app_discount: data.mobile_app_discount
            }
        };
    },
    createDraftInvoice: async (zipCode, locationId, item, promoQty) => {
        const digitalTotal = item.price * item.quantity;

        if (!isLoggedIn()) {
            return { success: false, prepaidWash: item, digitalTotal };
        }
        const accountId = 'USE-DEFAULT-ACCOUNT';
        const washTypeId = item?.serviceId;

        const refreshKey = `PREPAID-WASH-${washTypeId}-${locationId}`;

        if (item.refreshKey === refreshKey && has(item, 'invoice')) {
            return {
                success: true,
                digitalItem: item,
                digitalTotal: item.invoice.total
            };
        }

        if (item?.invoice?.stripe_invoice_id) {
            const id = item.invoice.stripe_invoice_id;
            // delete old draft invoice
            deleteInvoice(id, accountId).catch((e) => console.error(e.message));
        }

        const response = await ampFetch({
            route: 'api-user/prepaid-wash-promotion/create-invoice',
            options: {
                method: 'POST',
                body: JSON.stringify({
                    'Amp-Account-Id': accountId,
                    'wash_type_id': washTypeId,
                    'quantity': promoQty,
                    'promotion_id': item.bogoPrepaidPromotion.ampId,
                    'zip_code': zipCode,
                    'use_wallet_balance': true
                })
            }
        });

        if (response.success) {
            const digitalItem = prepaidWashes.updateItemWithInvoice(
                response.data,
                item,
                refreshKey
            );

            const hasInvoice = has(digitalItem, 'invoice');
            const finalTotal = hasInvoice
                ? digitalItem.invoice.subtotal
                : digitalTotal;

            return {
                prepaidWash: digitalItem,
                success: hasInvoice,
                digitalTotal: finalTotal
            };
        }

        return { success: false, prepaidWash: item, digitalTotal };
    },
    updateDraftInvoice: async (zipCode, locationId, item, newQuantity) => {
        if (!isLoggedIn()) {
            return { success: false, updatedWash: item };
        }
        const accountId = 'USE-DEFAULT-ACCOUNT';
        const washTypeId = item?.serviceId;

        const refreshKey = `PREPAID-WASH-UPDATE-${newQuantity}-${washTypeId}-${locationId}`;

        if (item.refreshKey === refreshKey && has(item, 'invoice')) {
            return {
                success: true,
                updatedWash: item
            };
        }

        const response = await ampFetch({
            route: 'api-user/prepaid-wash-promotion/update-invoice',
            options: {
                method: 'POST',
                body: JSON.stringify({
                    'Amp-Account-Id': accountId,
                    'wash_type_id': washTypeId,
                    'quantity': newQuantity,
                    'promotion_id': item.bogoPrepaidPromotion.ampId,
                    'zip_code': zipCode,
                    'use_wallet_balance': 1,
                    'stripe_invoice_id': item.invoice.stripe_invoice_id
                })
            }
        });

        if (response.success) {
            const digitalItem = prepaidWashes.updateItemWithInvoice(
                response.data,
                item,
                refreshKey
            );

            const hasInvoice = has(digitalItem, 'invoice');

            return {
                updatedWash: digitalItem,
                success: hasInvoice
            };
        }

        return { success: false, updatedWash: item };
    }
};

export default prepaidWashes;
